import { getDefaultLanguage, getLanguages } from '@rbilabs/intl';

import { FALLBACK_LOCALES } from 'utils/constants';
import { brand } from 'utils/environment';
import { getAppCountry, getRequestedLanguage } from 'utils/i18n';

export const loadLocale = () => {
  const appCountry = getAppCountry();

  const regionSupportedLanguages = getLanguages(brand(), appCountry) ?? FALLBACK_LOCALES;
  const hasMultipleLanguages = regionSupportedLanguages.length > 1;
  // If region has multiple languages, access language from selection history (or default if not available)
  // otherwise lock in default language
  const language = hasMultipleLanguages
    ? getRequestedLanguage()
    : getDefaultLanguage(brand(), appCountry);

  return { language, region: appCountry };
};
